import { useSyncExternalStore } from 'react';

// Touch-primary devices (phones, iPads, most tablets) cannot scroll multi-page
// PDFs embedded in a native <iframe> — only the first page renders. Gate on touch
// capability, not viewport width, so a narrow desktop window keeps the native
// iframe viewer (search/print/zoom) while still covering iPad at 768px+.
export const TOUCH_PRIMARY_MEDIA_QUERY = '(pointer: coarse) and (hover: none)';

function subscribe(callback: () => void) {
  if (typeof window === 'undefined') return () => {};
  const mql = window.matchMedia(TOUCH_PRIMARY_MEDIA_QUERY);
  if (typeof mql.addEventListener === 'function') {
    mql.addEventListener('change', callback);
    return () => mql.removeEventListener('change', callback);
  }
  mql.addListener(callback);
  return () => mql.removeListener(callback);
}

function getTouchPrimarySnapshot() {
  return window.matchMedia(TOUCH_PRIMARY_MEDIA_QUERY).matches;
}

function getTouchPrimaryServerSnapshot() {
  return false;
}

function useIsTouchPrimary(): boolean {
  return useSyncExternalStore(
    subscribe,
    getTouchPrimarySnapshot,
    getTouchPrimaryServerSnapshot
  );
}

/** Pure helper for unit tests and documentation. */
export function shouldUseScrollablePdf(isTouchPrimary: boolean): boolean {
  return isTouchPrimary;
}

/**
 * True when embedded PDFs should use the scrollable react-pdf viewer instead of
 * a native <iframe> (touch-primary phones, iPads, and tablets).
 */
export function useNeedsScrollablePdf(): boolean {
  return useIsTouchPrimary();
}
